import React, { Component } from "react";
import styles from "./tripUnitsBar.module.scss";
import TripUnitItem from "./TripUnitItem";
import { withLogisticTrips } from "../../../shared/containers/containerLogisticTrips";

class TripUnitListItems extends Component {
  render() {
    const { handleScrollTo, data, logisticSelectedTrip } = this.props;

    if (logisticSelectedTrip === null) {
      return null;
    }

    return data.map((item) => {
      return (
        <div className={styles.container_userUnitsListItem} key={item.id}>
          <TripUnitItem item={item} handleScrollTo={handleScrollTo} />
        </div>
      );
    });
  }
}

export default withLogisticTrips(React.memo(TripUnitListItems));
